import { Injectable } from '@angular/core';
import { BrowserStorageService } from './browser-storage.service';

@Injectable({
    providedIn: 'root'
})
export class PermissionService {
    constructor(private storage: BrowserStorageService) {}

    public retrivePermission(): any {
        const raw = localStorage.getItem('permission');
        if (!raw) return null;
        try {
            return JSON.parse(raw);
        } catch {
            // Legacy AES-encrypted value left over from a previous build — drop it.
            localStorage.removeItem('permission');
            return null;
        }
    }

    /**
     * "fname lname" of the signed-in member — the value create-quote-template stores
     * as a quote/sales order's `agent`, so it is what "own orders" filters compare to.
     */
    public retriveLoginMemberName(): string {
        // A missing or corrupt value yields '' (and a logged warning), which makes every
        // order read as someone else's: the safe direction for the privacy rule.
        const user = this.storage.getJson<any>('loginUserValue', {});
        return `${user?.fname || ''} ${user?.lname || ''}`.trim();
    }

    /** Language saved on the signed-in user ('en' / 'es' / 'fr'), or '' if unknown. */
    public retriveLoginLanguage(): string {
        const user = this.storage.getJson<any>('loginUserValue', {});
        return String(user?.languages?.locale || '');
    }

    storePermission(permission: any): void {
        localStorage.setItem('permission', JSON.stringify(permission));
    }
}
